import axios from "@/utils/api-v1"

export function getZipLocation(zip) {
  return axios.get(`/api/get-location/${zip}`)
}

export function getExpirationHours() {
  return axios.get(`/api/expiration-hours`)
}

export function sendSlackMessage(message) {
  return axios.post(`/api/send-slack-message`, { message })
}

export function logSlackError(user, email, message) {
  console.log("user, email, message", user, email, message)
  return axios.post(`/api/send-log-message`, { user, email, message })
}

export function getCategories() {
  return axios.get(`/api/categories`)
}
